<div
  *ngIf="
    model &&
    ((model.table && model.tablePagination) ||
      (model.tablePagination &&
        (model.tablePagination.type === POSITION.TOP ||
          model.tablePagination.type === POSITION.TOP_AND_BOTTOM)))
  "
  class="top-table-container"
>
  <rr-table-pagination
    *ngIf="
      model.table.results &&
      model.table.results.length &&
      (model.tablePagination.type === POSITION.TOP ||
        model.tablePagination.type === POSITION.TOP_AND_BOTTOM)
    "
    class="top-table-element"
    [model]="model.tablePagination"
    [position]="POSITION.TOP"
    (changedPage)="onPageChange($event)"
    (changePageSize)="onPageSizeChange($event)"
  ></rr-table-pagination>
  <rr-table-buttons
    class="top-table-element"
    [isLoading]="spinnerStatus.show"
    [recourdCount]="model.tablePagination.settings.recordCount"
    [addAction]="getAddAction()"
    [excelAction]="getExcelAction()"
    [fieldsToShow]="model.table.fieldsToShow"
    [visibleColumns]="model.table.visibleColumns"
    [addButtonLeft]="addButtonLeft"
    [addButtonRight]="addButtonRight"
    (actionClicked)="onActionClicked($event)"
    (changeVisibleColumns)="onVisibleColumnsChange($event)"
  >
  </rr-table-buttons>
</div>
<rr-table-batch-options
  *ngIf="model && model.table && showBatchOptions()"
  [showSelectAll]="model.table.showSelectAll"
  [recordCount]="RecordCount"
  [showSelectColumn]="model.table.showSelectColumn"
  [clearBatchOptions]="clearBatchOptions"
  [selectedRows]="selectedRows"
  [visibleBatchOptions]="model.visibleBatchOptions"
  (batchOptionClicked)="onBatchOptionClicked($event)"
  (selectAllClicked)="onSelectAllClicked()"
></rr-table-batch-options>
<rr-table
  *ngIf="model"
  [spinnerStatus]="spinnerStatus"
  [model]="model.table"
  [selectedEntities]="selectedRows"
  [selectedRadioEntity]="selectedRadioEntity"
  [clearRadioSelection]="clearRadioSelection"
  (sortBy)="onSortBy($event)"
  (actionClicked)="onActionClicked($event)"
  (rowsSelected)="onRowSelected($event)"
  (radioSelected)="onRadioSelected($event)"
  (radioSelectionCleared)="onRadioSelectionCleared()"
  (batchOptionCleared)="onBatchOptionCleared()"
  (rowClicked)="onRowClicked($event)"
></rr-table>
<rr-table-pagination
  *ngIf="
    model &&
    model.tablePagination &&
    model.table &&
    model.table.results &&
    model.table.results.length &&
    (model.tablePagination.type === POSITION.BOTTOM ||
      model.tablePagination.type === POSITION.TOP_AND_BOTTOM)
  "
  [model]="model.tablePagination"
  [position]="POSITION.BOTTOM"
  (changedPage)="onPageChange($event)"
  (changePageSize)="onPageSizeChange($event)"
></rr-table-pagination>
<div
  *ngIf="
    !(model && model.table && model.table.results && model.table.results.length)
  "
  class="pagination-container d-flex justify-content-between align-items-center bottom-pagination"
  style="height: 40px"
></div>
<rr-confirm-delete-modal
  [show]="showDeleteModal"
  [modalTitle]="deleteModalTitle"
  [contentType]="MODAL_CONTENT_TYPE.HTML"
  [modalContentTemplate]="confirmDeleteTemplate"
  (modalClosed)="onDeleteModalClosed($event)"
>
</rr-confirm-delete-modal>

<ng-template #confirmDeleteTemplate>
  <div [innerHTML]="deleteModalBodyText"></div>
</ng-template>
